import { usePermissions } from "components/context/permissionsContext";

export const useServicePermission = () => {
  const { userPermissions } = usePermissions();

  // Service Permissions
  const hasServiceSavePermission = userPermissions.some(
    (item) =>
      item.module === "Services" &&
      item.controller === "Service" &&
      item.action === "Save" &&
      item.hasPermission
  );
  const hasServiceGetPermission = userPermissions.some(
    (item) =>
      item.module === "Services" &&
      item.controller === "Service" &&
      item.action === "Get" &&
      item.hasPermission
  );
  const hasServiceDeletePermission = userPermissions.some(
    (item) =>
      item.module === "Services" &&
      item.controller === "Service" &&
      item.action === "Delete" &&
      item.hasPermission
  );
  const hasServiceSoftDeletePermission = userPermissions.some(
    (item) =>
      item.module === "Services" &&
      item.controller === "Service" &&
      item.action === "SoftDelete" &&
      item.hasPermission
  );
  const hasServiceIndustriesGetPermission = userPermissions.some(
    (item) =>
      item.module === "Services" &&
      item.controller === "Service" &&
      item.action === "GetIndustries" &&
      item.hasPermission
  );

  // Bundle Permissions
  const hasBundleSavePermission = userPermissions.some(
    (item) =>
      item.module === "Services" &&
      item.controller === "Bundle" &&
      item.action === "Save" &&
      item.hasPermission
  );
  const hasBundleGetPermission = userPermissions.some(
    (item) =>
      item.module === "Services" &&
      item.controller === "Bundle" &&
      item.action === "Get" &&
      item.hasPermission
  );
  const hasBundleDeletePermission = userPermissions.some(
    (item) =>
      item.module === "Services" &&
      item.controller === "Bundle" &&
      item.action === "Delete" &&
      item.hasPermission
  );
  const hasBundleSoftDeletePermission = userPermissions.some(
    (item) =>
      item.module === "Services" &&
      item.controller === "Bundle" &&
      item.action === "SoftDelete" &&
      item.hasPermission
  );

  const ServicePermissionProps = {
    // Service Permissions
    hasServiceSavePermission,
    hasServiceGetPermission,
    hasServiceDeletePermission,
    hasServiceSoftDeletePermission,
    hasServiceIndustriesGetPermission,

    // Bundle Permissions
    hasBundleSavePermission,
    hasBundleGetPermission,
    hasBundleDeletePermission,
    hasBundleSoftDeletePermission
  };

  return {
    ServicePermissionProps,
  };
};
